<template>
  <div class="custom-control custom-checkbox">
    <input
      :id="id"
      type="checkbox"
      class="custom-control-input btn-primary"
      :checked="checked"
      :disabled="disabled"
      :indeterminate.prop="indeterminate"
      :tabindex="tabindex"
      :value="value"
      :aria-label="ariaLabel"
      @change="change"
    />
    <label class="custom-control-label" :for="id"
      ><slot>{{ label }}</slot></label
    >
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid';

export default {
  name: 'WCCheckbox',
  model: {
    prop: 'model',
    event: 'change',
  },
  props: {
    id: {
      type: String,
      default: () => uuid(),
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: true,
    },
    model: {
      type: [Boolean, Array],
    },
    tabindex: {
      type: String,
      default: null,
    },
    ariaLabel: {
      type: String,
      default: '',
    },
  },
  computed: {
    checked() {
      return Array.isArray(this.model)
        ? this.model.includes(this.value)
        : this.value === this.model;
    },
  },
  methods: {
    change($event) {
      const { checked } = $event.target;
      if (Array.isArray(this.model)) {
        this.$emit(
          'change',
          checked ? [...this.model, this.value] : this.model.filter(e => e !== this.value),
        );
      } else {
        this.$emit('change', checked ? this.value : !this.value);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.custom-control {
  user-select: none;
}
.custom-control-input:checked ~ .custom-control-label::before {
  background-color: var(--primary, $primary);
  border-color: var(--primary, $primary);
}
.custom-control-label::before {
  border-color: var(--dark, $dark);
}
</style>
